import { ApiError } from '@d-orca/shared/client/apis';
import { ISSUE_PHOTO_TYPES, isUploadablePhoto } from '@d-orca/shared/client/issues';

// ---------------------------------------------------------------------------
// What a task photo may be, and why one was refused. The rule is the backend's
// image-upload rule (JPEG, PNG, WebP or GIF, up to 10 MB) — one rule for an
// issue photo, a comment photo and a checklist's evidence. The picker offers
// only those types, a file it lets through anyway ("All files", a drag) is
// refused before uploading, and a refusal the server still makes is named by
// its status. HEIC and PDF are refused, not converted (D10).
// ---------------------------------------------------------------------------

export type PhotoRefusal = 'type' | 'size' | 'upload';

/** The `accept` list a task photo input offers. */
export const PHOTO_ACCEPT = ISSUE_PHOTO_TYPES.join(',');

/** Why `file` can't be uploaded, or null when it can. */
export function photoRefusal(file: File): PhotoRefusal | null {
  if (!ISSUE_PHOTO_TYPES.includes(file.type)) return 'type';
  return isUploadablePhoto(file.type, file.size) ? null : 'size';
}

/** Why an upload failed: the server named the type (415) or the size (413),
 *  or it failed for some other reason. */
export function uploadRefusal(error: unknown): PhotoRefusal {
  if (error instanceof ApiError && error.status === 415) return 'type';
  if (error instanceof ApiError && error.status === 413) return 'size';
  return 'upload';
}

/** The message for a refusal. */
export const PHOTO_REFUSAL_KEY: Readonly<Record<PhotoRefusal, string>> = {
  type: 'scheduler.panel.photoRefused.type',
  size: 'scheduler.panel.photoRefused.size',
  upload: 'scheduler.panel.photoRefused.upload',
};
